{
	"language": {
		"aria": "Muuda keelt"
	},
	"placeholder": {
		"title": "Sinu kandidaadikeskus on peagi valmis",
		"body": "Siin ei ole veel midagi. Saadame sulle e-kirja teel lingi, kui see on valmis."
	},
	"not_found": {
		"title": "Lehte ei leitud",
		"body": "Kontrolli linki, mida järgisid, või kasuta oma e-kirjas olevat linki."
	},
	"error_boundary": {
		"reload": "Laadi leht uuesti"
	},
	"login": {
		"loading": "Laadimine…",
		"title": "Logi oma kandidaadikeskusesse sisse",
		"intro": "Sisesta oma e-posti aadress, et näha oma taotlusi.",
		"email_label": "E-posti aadress",
		"email_placeholder": "sina@näide.ee",
		"submit": "Logi sisse",
		"sending": "Saatmine…",
		"sent": {
			"title": "Kontrolli oma e-posti",
			"body": "Kui {{email}} vastab mõnele taotlusele, on sisselogimislink teel.",
			"retry": "Ei saanud kätte? Kontrolli aadressi ja proovi uuesti"
		},
		"resent": {
			"title": "Saatsime sulle uue sisselogimislingi",
			"body": "Avatud link on aegunud. Kui sinu e-posti aadress vastab mõnele taotlusele, on uus sisselogimislink teel. See avab sama lehe.",
			"request_manually": "Ei saanud kätte? Küsi uut linki"
		},
		"request_error": {
			"throttled": "Liiga palju katseid. Palun oota hetk ja proovi uuesti.",
			"invalid_email": "Palun sisesta kehtiv e-posti aadress.",
			"generic": "Midagi läks valesti. Palun proovi uuesti."
		},
		"unknown_organisation": {
			"title": "Lehte ei leitud",
			"body": "Kontrolli linki, mida järgisid, või kasuta oma e-kirjas olevat linki."
		},
		"error": {
			"title": "Midagi läks valesti",
			"body": "Me ei saanud seda lehte laadida. Palun proovi hetke pärast uuesti."
		}
	},
	"organisations": {
		"title": "Sinu taotlused",
		"intro": "Vali ettevõte, et näha talle saadetud taotlusi.",
		"count_one": "{{count}} taotlus",
		"count_other": "{{count}} taotlust",
		"empty": {
			"title": "Taotlusi veel ei ole",
			"body": "Kui kandideerid mõnda ettevõttesse, ilmub see siia."
		},
		"error": "Me ei saanud sinu ettevõtteid laadida. Palun proovi hetke pärast uuesti.",
		"log_out": "Logi välja",
		"logging_out": "Väljalogimine…"
	},
	"submissions": {
		"title": "Varasemad taotlused",
		"back_to_organisations": "Kõik ettevõtted",
		"cv_uploaded": "CV üles laaditud",
		"empty": {
			"title": "Taotlusi veel ei ole",
			"body": "Taotlused, mille saadad ettevõttele {{organisation}}, ilmuvad siia."
		},
		"error": "Me ei saanud sinu taotlusi laadida. Palun proovi hetke pärast uuesti.",
		"log_out": "Logi välja",
		"logging_out": "Väljalogimine…"
	},
	"profile": {
		"link": {
			"title": "Sinu profiil",
			"cv_added": "CV lisatud",
			"cv_missing": "CV-d veel pole"
		},
		"back": "Tagasi taotluse juurde",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Oled nõus, et sinuga selle töökoha osas ühendust võetakse.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Laadi oma CV üles",
				"drop_hint": "või lohista see siia",
				"constraints": "{{types}}, kuni {{size}} MB",
				"uploading": "Laadin üles faili {{fileName}}…",
				"done": "CV üles laaditud",
				"error_type": "Seda failitüüpi ei toetata. Lubatud tüübid: {{types}}.",
				"error_size": "Fail on liiga suur. Maksimaalne suurus on {{size}} MB."
			},
			"remove": {
				"label": "Eemalda {{fileName}}",
				"question": "Kas eemaldada {{fileName}}?",
				"consequence": "Tööandja ei näe seda enam. Seda ei saa tagasi võtta.",
				"confirm": "Eemalda CV",
				"cancel": "Tühista",
				"removing": "Eemaldan…",
				"error": "CV eemaldamine ebaõnnestus. Proovi uuesti."
			}
		},
		"work_history": {
			"title": "Töökogemus",
			"description": "Räägi meile oma asjakohasest töökogemusest: kus sa töötasid, mida sa seal tegid ja kui kaua sa seal töötasid. Võid lisada rohkem kui ühe töökoha, kui need on asjakohased.",
			"placeholder": "Kirjelda töökohta, kus oled töötanud",
			"input_label": "Töö andmed",
			"save": "Salvesta",
			"saving": "Salvestamine…",
			"cancel": "Tühista",
			"edit": "Muuda",
			"remove": "Eemalda",
			"add_another": "Lisa veel üks töökoht",
			"error_empty": "Kirjuta enne salvestamist midagi.",
			"error_limit": "Saad lisada kuni {{max}} töökohta.",
			"unsaved_changes": "Sinu töökogemuses on salvestamata muudatusi. Kas soovid siiski lahkuda ja need kaotada?",
			"hints": {
				"label": "Selle töö andmed",
				"included": "olemas",
				"missing": "veel mainimata"
			}
		},
		"education": {
			"title": "Haridus",
			"description": "Räägi meile oma asjakohasest haridusest: mida sa õppisid, kus ja millal. Arvesse lähevad kraadid, koolid, kursused ja tunnistused. Võid lisada rohkem kui ühe.",
			"placeholder": "Kirjelda kraadi, kooli või kursust",
			"input_label": "Hariduse andmed",
			"save": "Salvesta",
			"saving": "Salvestamine…",
			"cancel": "Tühista",
			"edit": "Muuda",
			"remove": "Eemalda",
			"add_another": "Lisa veel üks haridus",
			"error_empty": "Kirjuta enne salvestamist midagi.",
			"error_limit": "Saad lisada kuni {{max}} hariduskirjet.",
			"unsaved_changes": "Sinu hariduse andmetes on salvestamata muudatusi. Kas soovid siiski lahkuda ja need kaotada?"
		},
		"licenses": {
			"title": "Load ja sertifikaadid",
			"description": "Räägi meile oma lubadest ja sertifikaatidest, näiteks juhiluba, tõstukijuhi luba või hügieenitõend. Märgi, millal sa selle said ja millal see aegub, kui see aegub. Võid lisada rohkem kui ühe.",
			"placeholder": "Kirjelda luba või sertifikaati",
			"input_label": "Loa andmed",
			"save": "Salvesta",
			"saving": "Salvestamine…",
			"cancel": "Tühista",
			"edit": "Muuda",
			"remove": "Eemalda",
			"add_another": "Lisa veel üks luba",
			"error_empty": "Kirjuta enne salvestamist midagi.",
			"error_limit": "Saad lisada kuni {{max}} luba.",
			"unsaved_changes": "Sinu lubade andmetes on salvestamata muudatusi. Kas soovid siiski lahkuda ja need kaotada?"
		}
	},
	"submission": {
		"back": "Tagasi minu taotluste juurde",
		"back_short": "Tagasi",
		"not_found": {
			"title": "Taotlust ei leitud",
			"body": "Seda taotlust ei ole olemas või see ei ole sinu oma."
		},
		"result": {
			"heading": "Kinnitusekraan, mida nägid pärast kandideerimist"
		},
		"summary": {
			"title": "Sinu vastuste kokkuvõte",
			"submitted_on": "Esitasid selle vormi",
			"submitted_more_than_once": "Täitsid selle vormi rohkem kui üks kord. Ühendame sinu profiili automaatselt; allolev taotlus on kõige uuem."
		}
	}
}
